import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { CurrencyStore } from 'core/stores/currency.store';
import { AmountToPayStore } from '../amount-to-pay.store';
import styles from '../amount-to-pay.module.scss';

export const AmountInputMessage = observer<{
  amountToPayStore: AmountToPayStore;
  currencyStore: CurrencyStore;
}>(({ amountToPayStore, currencyStore }) => {
  const { t } = useTranslation();

  if (!amountToPayStore.isEditingValue) {
    return undefined;
  }

  if (amountToPayStore.isAmountBelowMin) {
    return (
      <div className={styles.errorNote}>
        {t('account.amountToPay.validation.min', {
          min: currencyStore.getCurrencyValue(amountToPayStore.validation.min),
        })}
      </div>
    );
  }

  if (amountToPayStore.isAmountAboveMax) {
    return (
      <div className={styles.errorNote}>
        {t('account.amountToPay.validation.max', {
          max: currencyStore.getCurrencyValue(amountToPayStore.validation.max),
        })}
      </div>
    );
  }

  return undefined;
});